// import React from 'react';
// import './DynamicBackground.css';

// const DynamicBackground = () => {
//   return (
//     <div className="dynamic-background">
//       <div className="content">
//         <h2>AI-Powered Computer Vision Solutions</h2>
//         <p>Explore Druma.ai's cutting-edge SaaS offerings in computer vision and analytics.</p>
//       </div>
//     </div>
//   );
// };

// export default DynamicBackground;


import React from 'react';
import './DynamicBackground.css';

const DynamicBackground = () => {
  return (
    <div className="dynamic-background">
      <div className="content">
        <h2>AI-Powered Computer Vision Solutions</h2>
        <p>Explore Druma.ai's cutting-edge SaaS offerings in computer vision and analytics.</p>
      </div>
    </div>
  );
};

export default DynamicBackground;
